import { toast } from "sonner";
import { api, errText, fmt, fmtPx, signed } from "@/lib/api";

export function PositionsTable({ positions = [], onChange, compact, onReplay }) {
  const close = async (id) => {
    try { const { data } = await api.post(`/positions/${id}/close`); toast.success(`Closed · P&L ${signed(data.pnl)} USDT`); onChange?.(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="overflow-x-auto" data-testid="positions-table">
      <table className="grid">
        <thead><tr>
          <th>Symbol</th><th>Side</th><th className="num">Entry</th><th className="num">Mark</th><th className="num">Size</th>{!compact && <th className="num">Lev</th>}
          <th className="num">Stop</th><th className="num">TP1 / TP2</th><th className="num">Unrealized</th>{!compact && <th>Strategy</th>}<th></th>
        </tr></thead>
        <tbody>
          {positions.length === 0 && <tr><td colSpan={11} className="text-center text-[#5e6673] py-6">No open positions</td></tr>}
          {positions.map((p) => {
            const pnlPct = p.entry_price ? ((p.side === "LONG" ? 1 : -1) * (p.current_price - p.entry_price) / p.entry_price * 100) : 0;
            return (
              <tr key={p.id} data-testid={`position-row-${p.symbol}`}>
                <td className="font-semibold text-white">{p.symbol}</td>
                <td><span className={`pill ${p.side === "LONG" ? "bg-[rgba(14,203,129,0.12)] text-[#0ecb81]" : "bg-[rgba(246,70,93,0.12)] text-[#f6465d]"}`}>{p.side}</span></td>
                <td className="num">{fmtPx(p.entry_price)}</td><td className="num text-white">{fmtPx(p.current_price)}</td><td className="num">{fmt(p.size, 5)}</td>
                {!compact && <td className="num">{p.leverage}x</td>}
                <td className="num text-[#f6465d]">{fmtPx(p.stop_loss)}</td>
                <td className="num text-[#0ecb81]">{(p.take_profit || []).map(fmtPx).join(" / ")}</td>
                <td className={`num ${p.unrealized_pnl >= 0 ? "up" : "down"}`}>{signed(p.unrealized_pnl)} <span className="text-[10px]">({signed(pnlPct)}%)</span></td>
                {!compact && <td className="text-[#848e9c]">{p.strategy || "—"}</td>}
                <td><div className="flex gap-1">{onReplay && <button onClick={() => onReplay(p.id)} className="btn-ghost rounded px-2 h-6 text-[10px]" data-testid={`replay-position-${p.symbol}`}>Replay</button>}<button onClick={() => close(p.id)} className="btn-ghost rounded px-2 h-6 text-[10px]" data-testid={`close-position-${p.symbol}`}>Close</button></div></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
